import { PageItemApi } from 'api/PageItemApi';

export type AnswerDto = {
  id?: number;
  option?: number;
  answer?: string;
  // TODO: it should be always a number
  question?: number | PageItemApi.Entry;
  questionId?: number;
};

export type AnswerModel = {
  id?: number;
  option?: number;
  answer?: string;
  question?: number;
};

export function mapAnswerDtoToModel(dto: AnswerDto): AnswerModel {
  return {
    id: dto.id,
    option: dto.option !== null ? dto.option : undefined,
    answer: dto.answer !== null ? dto.answer : undefined,
    question: dto.question ? (dto.question as PageItemApi.Entry).id : undefined,
  };
}
